export const TYPE_LOCAL_BUSINESS = {
  "cham-soc-da-massage": "DaySpa",
  "lam-toc-mong": "HairSalon",
  "tham-my-vien": "BeautySalon",
  "phong-kham": "HealthClub",
  "the-duc-the-thao": "HealthClub",
  "xam-hinh": "TattooParlor",
};
import gs from "gstyles";

const CATEGORY_SIZE = 52;
export const CATEGORIES = [
  {
    icon: gs.icons({ name: "category-salon", size: CATEGORY_SIZE }),
    iconName: "category-salon",
    code: "M1",
    name: "Salon mi và móng",
  },
  {
    icon: gs.icons({ name: "category-spa", size: CATEGORY_SIZE }),
    iconName: "category-spa",
    code: "M2",
    name: "Spa chăm da",
  },
  {
    icon: gs.icons({ name: "category-massage", size: CATEGORY_SIZE }),
    iconName: "category-massage",
    code: "M3",
    name: "Massage gội đầu",
  },
  {
    icon: gs.icons({ name: "category-tham-my", size: CATEGORY_SIZE }),
    iconName: "category-tham-my",
    code: "M4",
    name: "Thẩm mỹ nha khoa",
  },
  {
    icon: gs.icons({ name: "category-toc", size: CATEGORY_SIZE }),
    iconName: "category-toc",
    code: "M5",
    name: "Salon tóc Make-up",
  },
  {
    icon: gs.icons({ name: "category-workshop", size: CATEGORY_SIZE }),
    iconName: "category-workshop",
    code: "M6",
    name: "Workshop",
  },
  {
    icon: gs.icons({ name: "category-gym", size: CATEGORY_SIZE }),
    iconName: "category-gym",
    code: "05",
    name: "Gym yoga Dance",
  },
  {
    icon: gs.icons({
      name: "category-life-coach",
      size: CATEGORY_SIZE,
    }),
    iconName: "category-life-coach",
    code: "M7",
    name: "Life coach",
  },
];
